var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9338 2.62804C16.3218 1.68193 17.6616 1.68193 18.0496 2.62804L21.3425 10.6572L30.2096 11.4345C31.2301 11.5239 31.6271 12.8069 30.8356 13.4571L24.7889 18.4243C24.4579 18.6963 24.3066 19.1305 24.3971 19.5493L26.2885 28.3061C26.5055 29.3109 25.3896 30.0694 24.5351 29.498L16.9917 24.4532L9.44826 29.498C8.59376 30.0694 7.47791 29.3109 7.69494 28.3061L9.58631 19.5493C9.67676 19.1305 9.52551 18.6963 9.19446 18.4243L3.14782 13.4571C2.35628 12.8069 2.75333 11.5239 3.77379 11.4345L12.6409 10.6572L15.9338 2.62804Z",
    fill: "#84C70D",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9338 2.62804C16.3218 1.68193 17.6616 1.68193 18.0496 2.62804L21.3425 10.6572L30.2096 11.4345C31.2301 11.5239 31.6271 12.8069 30.8356 13.4571L24.7889 18.4243C24.4579 18.6963 24.3066 19.1305 24.3971 19.5493L26.2885 28.3061C26.5055 29.3109 25.3896 30.0694 24.5351 29.498L16.9917 24.4532L9.44826 29.498C8.59376 30.0694 7.47791 29.3109 7.69494 28.3061L9.58631 19.5493C9.67676 19.1305 9.52551 18.6963 9.19446 18.4243L3.14782 13.4571C2.35628 12.8069 2.75333 11.5239 3.77379 11.4345L12.6409 10.6572L15.9338 2.62804Z",
    stroke: "#84C70D",
    strokeWidth: 3.43035,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStar);
export default __webpack_public_path__ + "static/media/payment-star.2acd963e336d0955bbb9f5d8457b5720.svg";
export { ForwardRef as ReactComponent };